module.exports = __webpack_public_path__ + "img/side_mount.00557134.png";